import { render, staticRenderFns } from "./UploadMedien.vue?vue&type=template&id=33a3f7df"
import script from "./UploadMedien.vue?vue&type=script&lang=js"
export * from "./UploadMedien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports